import React, { FC } from 'react';
import classNames from 'classnames';
import { Link } from '@/navigation';
import { getCtaTextStyles } from '@/components/utils';

export interface GenInternalLinkProps {
  href: string;
  cta: string;
  testId?: string;
  classes?: string;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
}

const GenInternalLink: FC<GenInternalLinkProps> = ({
  href,
  cta,
  classes,
  testId,
  onClick,
}) => {
  return (
    <Link
      href={href}
      className={classNames(
        `w-fit underline font-bold ${getCtaTextStyles()}`,
        classes,
      )}
      data-testid={testId}
      onClick={onClick}
    >
      {cta}
    </Link>
  );
};

export default React.memo(GenInternalLink);
